<template>
  <div
    class="
      flex flex-col justify-between
      w-80 h-56
      border-1 border-solid border-blue rounded-2xl
      mx-1 px-3 py-2
    "
  >
    <loading-icon v-if="isLoading || !audienceKpi" class="flex h-full self-center opacity-50" />
    <template v-else>
      <div class="flex justify-between">
        <div class="text-xl">{{ name }}</div>
        <div class="flex flex-col text-right">
          <span class="text-2xl font-secondary">
            <slot name="rightTitle"></slot>
          </span>
          <span class="text-md leading-none">
            <slot name="rightSubtitle"></slot>
          </span>
          <TrendArrow :value="Math.round(audienceKpi.trend)" :text-after="`${Math.round(audienceKpi.trend)}%`" />
        </div>
      </div>
      <bar-chart
          :data="
            audienceKpi.series.map((row) => {
              return { ...row, value: parseInt(row.value) };
            })
          "
          :height="180"
          cssTooltipClasses="w-auto transform translate-y-4 whitespace-nowrap"
      />
    </template>
  </div>
</template>

<script>
import TrendArrow from "./TrendArrow";
import { LoadingIcon, BarChart } from "@springbig/sb-components";

export default {
  name: 'KpiTile',
  components: {
    TrendArrow,
    LoadingIcon,
    BarChart,
  },
  props: {
    name: String,
    audienceKpi: Object,
    isLoading: Boolean,
  }
};
</script>
